// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"6dd7b5d5","361":"1748c037","568":"ba5f7a5c","767":"c0699f01"}[chunkId] + ".chunk.js";
};